import { RHFAutoComplete } from '@openx/components-core/lib/AutoComplete/RHFAutoComplete';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { RHFTextField } from '@openx/components-core/lib/TextField/RHFTextField';
import { RIGHT_COLUMN_WIDTH } from '@openx/constants/form';
import { PackageFields, PrivateMarketFields } from '@openx/types/package';
import { useCallback, useMemo } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { MERCHANDISING_DESCRIPTION, packageLabels } from '../constants';

export function MerchandisingSection() {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const observableDomains = useWatch({ name: PackageFields.DOMAINS });
  const observableDiscoverable = useWatch({
    name: `${PackageFields.PRIVATE_MARKET}.${PrivateMarketFields.DISCOVERABLE}`,
  });

  const domainsLabel = useMemo(
    () => (observableDiscoverable ? t('Domains or App names') : packageLabels(t)[PackageFields.DOMAINS]),
    [observableDiscoverable, t]
  );

  const domains = useMemo(() => observableDomains?.split(',').filter(v => !!v) || [], [observableDomains]);

  const onDomainChange = useCallback(
    (_, value) => {
      setValue(PackageFields.DOMAINS, value.join(','));
    },
    [setValue]
  );

  return (
    <FormSection
      divider
      title={t('Merchandising Details')}
      description={MERCHANDISING_DESCRIPTION(t)}
      rightColumnSize={RIGHT_COLUMN_WIDTH}
      name="Merchandising"
    >
      <RHFTextField
        name={PackageFields.LOGO}
        label={packageLabels(t)[PackageFields.LOGO]}
        placeholder={t('Enter logo link here (example: {link})', { link: 'http://openx.com/ox_logo.png' })}
        fullWidth
        dataTest="logo"
      />
      <RHFAutoComplete
        name={PackageFields.DOMAINS}
        textFieldProps={{
          label: domainsLabel,
          margin: 'dense',
          placeholder: t('Enter a Domain or App Name'),
        }}
        fullWidth
        freeSolo
        options={[]}
        multiple
        limitTags={4}
        disableClearable
        value={domains}
        onChange={onDomainChange}
        data-test="domains"
        autoSelect
      />
      <RHFAutoComplete
        name={PackageFields.URLS}
        textFieldProps={{
          label: packageLabels(t)[PackageFields.URLS],
          margin: 'dense',
          placeholder: t('Enter Sample URLs'),
        }}
        fullWidth
        freeSolo
        options={[]}
        multiple
        limitTags={3}
        disableClearable
        data-test="urls"
        autoSelect
      />
    </FormSection>
  );
}
